__webpack_require__.p = "/card-page/";